import React from 'react'

export default function Projects() {
  return (
    <div className='container'>
        <div className='d-flex justify-content-between align-items-center my-5'>
        <p className='h3 fw600'>Recent Projects</p>
        <p className='grey-text'>Here are some of the project I've worked on recently.</p>
        </div>
        <div className="row">
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-4 project-img' src="./img/Oyemexchange-Portfolio.png" alt="Oyemexchange Project" />
            <p className='grey-text mb-2'>Fullstack Development</p>
            <p className='h4 fw-bold'><a href="https://oyemexchange.com">OyemExchange</a></p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Onlinedrugcrib.png" alt="Onlinedrugcrib Project" />
            <p className='grey-text mb-2'>Web Development</p>
            <p className='h4 fw-bold'><a href="https://onlinedrugcrib.com">Onlinedrugcrib</a></p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Dappa.png" alt="Dappa Project" />
            <p className='grey-text mb-2'>Branding | Graphic Design | Development</p>
            <p className='h4 fw-bold'>Dappa</p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Wheatstonegates.png" alt="Wheatstonegates Project" />
            <p className='grey-text mb-2'>Web Development</p>
            <p className='h4 fw-bold'><a href="https://wheatstonegates.com">Wheatstonegates</a></p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Raverstudio.png" alt="Raverstudio Project" />
            <p className='grey-text mb-2'>Web Development</p>
            <p className='h4 fw-bold'><a href="https://raver.studio">Raverstudio</a></p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Triveapp-Portfolio.png" alt="Triveapp Project" />
            <p className='grey-text mb-2'>Web Development</p>
            <p className='h4 fw-bold'><a href="https://triveapp.com">Triveapp</a></p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Healthbay-Portfolio.png" alt="Healthbay Project" />
            <p className='grey-text mb-2'>Web Development</p>
            <p className='h4 fw-bold'><a href="https://healthbay.care">Healthbay</a></p>
        </div>
        <div className='col-md-6 col-sm-12 mb-5'>
            <img className='img-fluid mb-3 project-img' src="./img/Vixus-Portfolio.png" alt="Vixus Project" />
            <p className='grey-text mb-2'>Fullstack Development</p>
            <p className='h4 fw-bold'><a href="https://vixusdirectliving.com.au">Vixus Direct Living, Australia</a><span className='h6 text-muted'> (In dev mode)</span></p>
        </div>
    </div>
    </div>
    
  )
}
